<app-base-action-modal
  modalTitle="Change Member Email"
  i18n-modalTitle
  primaryLabel="Confirm Email Change"
  i18n-primaryLabel
  secondaryLabel="Cancel"
  i18n-secondaryLabel
  (closeClicked)="closeModal()"
  (primaryClicked)="form.submitForm()"
  (secondaryClicked)="closeModal()">
  <div i18n class="mb-3">Change the email address that the member will use to login.</div>
  <lib-reactive-form-group
    #form
    [bindTo]="req$ | async"
    [isLoading]="isLoading$ | async"
    (formSubmitted$)="submitForm($event)">
    <lib-reactive-form-email
      [required]="true"
      [disabled]="true"
      label="Current Email Address"
      i18n-label
      [bindingProperty]="'currentEmail'"
      [inputName]="'currentEmail'"
      [programmaticallyChangeValue]="userEmail$ | async" />
    <lib-reactive-form-email
      [required]="true"
      label="New Email Address"
      i18n-label
      [bindingProperty]="'newEmail'"
      [inputName]="'email'" />
    <lib-reactive-form-email
      [required]="true"
      label="Confirm New Email Address"
      i18n-label
      [confirmEmail]="true"
      [inputName]="'confirmEmail'" />
  </lib-reactive-form-group>
</app-base-action-modal>
